import React from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { default as New } from './ScheduledTransactionEditDialog';
import { default as Legacy } from './ScheduledTransactionEditDialog_legacy';

const ScheduledTransactionEditDialog = (props) => {
  const customFrequency = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'customFrequency'));
  return customFrequency ? <New {...props} /> : <Legacy {...props} />;
};

export default ScheduledTransactionEditDialog;
